import { atom } from 'jotai';

import { BoardArticle, BoardCategory, FilterValueType } from 'src/types/board';

export const filterValue = atom<FilterValueType>('ALL');

export const handleSetFilter = atom(filterValue, (get, set, value: FilterValueType) =>
  set(filterValue, value)
);

export const pinnedBoardPost = atom<BoardArticle[]>([]);

export const boardCategory = atom<BoardCategory[]>([]);

export const selectedBoardCatgory = atom<string>('');

export const handleSetSelectedCategory = atom(selectedBoardCatgory, (get, set, value: string) =>
  set(selectedBoardCatgory, value)
);

export const sizeToFetch = atom<number>(10);

export const socialLearningDataAtom = atom<any>(null);

export const communityDataAtom = atom<any>(null);
